import { render, staticRenderFns } from "./GanttAside.vue?vue&type=template&id=b9de0a6e&scoped=true&lang=pug&"
import script from "./GanttAside.vue?vue&type=script&lang=js&"
export * from "./GanttAside.vue?vue&type=script&lang=js&"
import style0 from "./GanttAside.vue?vue&type=style&index=0&id=b9de0a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de0a6e",
  null
  
)

export default component.exports